<!--质量检测表单-->
<template>
    <div class="test-form">
        <h4>快检</h4>
        <div class="popup-container">
            <div class="panel">
                <div class="title">
                    <label><i class="iconfont iconpinjiantixi"></i>快检项目</label>
                    <div class="show-hide" @click="showItem=!showItem">
                        <span v-show="!showItem">展开<i class="iconfont iconshuangjiantouxia"></i></span>
                        <span v-show="showItem">收起<i class="iconfont iconshuangjiantoushang"></i></span>
                    </div>
                </div>
                <div v-show="showItem">
                    <div class="item-pannel" v-for="(item, index) in dataInfo.qualityDetails" :key="index">
                        <div class="row-item">
                            <div :class="['au-item-title',item.is_must_check?'must-check':'']">
                                <label>{{ item.item_name }}</label>
                                <span class="diff-weight" v-if="item.is_deduction_weight">
                                    扣吨百分比:{{ item.deduction_weight_rate==null?'--':item.deduction_weight_rate+'%' }}
                                </span>
                            </div>
                            <div :class="['state',getTestResultText(item.result).class]">
                                {{ getTestResultText(item.result).txt }}
                                <van-popover v-model="item.showPopover" trigger="click" placement="bottom-end">
                                    <div class="popver-box">
                                        <p class="zhibiao">
                                            合格指标：<span v-text="getUnitStr(item.standard_index,item.unit,item.index_type)"></span>
                                        </p>
                                        <p class="zhibiao">
                                            让步指标：<span v-text="getUnitStr(item.compromise_index,item.unit,item.index_type)"></span>
                                        </p>
                                        <p class="zhibiao">
                                            不合格指标：<span v-text="getUnitStr(item.not_standard_index,item.unit,item.index_type)"></span>
                                        </p>
                                    </div>
                                    <template #reference>
                                        <i class="iconfont iconiconset0143"></i>
                                    </template>
                                </van-popover>
                            </div>
                        </div>
                        <div class="row-item">
                            <div class="au-item-title real">
                                <span>实际指标</span>
                                <div class="rel-val" v-if="item.index_type==0">
                                    <input
                                        type="number"
                                        maxlength="10"
                                        placeholder="请输入"
                                        v-model="item.actual_value"
                                        @input="setResult(item)"
                                    >
                                    <i class="unit">{{ item.unit }}</i>
                                </div>
                                <van-radio-group
                                    v-else
                                    v-model="item.actual_value"
                                    direction="horizontal"
                                    icon-size="12px"
                                    @change="setResult(item)"
                                >
                                    <van-radio v-if="item.standard_index" :name="item.standard_index">
                                        {{ item.standard_index+item.unit }}
                                    </van-radio>
                                    <van-radio v-if="item.compromise_index" :name="item.compromise_index">
                                        {{ item.compromise_index+item.unit }}
                                    </van-radio>
                                    <van-radio v-if="item.not_standard_index" :name="item.not_standard_index">
                                        {{ item.not_standard_index+item.unit }}
                                    </van-radio>
                                </van-radio-group>
                            </div>
                            <div class="au-item-title real">
                                <span>合格指标：</span><strong>{{ getUnitStr(item.standard_index,item.unit,item.index_type) }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel test-result">
                <div class="title">
                    <label><i class="iconfont icondingdanqueren"></i>质检结果</label>
                </div>
                <div class="result-radio">
                    <van-radio-group
                        v-model="dataInfo.quality.result"
                        direction="horizontal"
                        icon-size="12px"
                        @change="changeResult"
                        :disabled="isEnabledStandard"
                    >
                        <van-radio :name="1">
                            合格
                        </van-radio>
                        <van-radio :name="2">
                            让步
                        </van-radio>
                        <van-radio :name="3">
                            不合格
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="panel">
                <div class="title">
                    <label><i class="iconfont iconrenwu"></i>处理结果</label>
                    <div class="show-hide" @click="showResult=!showResult">
                        <span v-show="!showResult">展开<i class="iconfont iconshuangjiantouxia"></i></span>
                        <span v-show="showResult">收起<i class="iconfont iconshuangjiantoushang"></i></span>
                    </div>
                </div>
                <div v-show="showResult">
                    <van-radio-group
                        v-model="dataInfo.quality.handle_result"
                        direction="horizontal"
                        icon-size="12px"
                    >
                        <van-radio :name="1" disabled>
                            合格接收
                        </van-radio>
                        <van-radio :name="2" disabled>
                            让步接收
                        </van-radio>
                        <van-radio :name="3" :disabled="[null,0,1,2].includes(dataInfo.quality.result)">
                            退货
                        </van-radio>
                        <van-radio :name="4" :disabled="[null,0,1,2].includes(dataInfo.quality.result)">
                            不合格接收
                        </van-radio>
                    </van-radio-group>
                    <van-cell-group>
                        <!-- <van-cell @click="showStockPop" :value="dataInfo.balance.stock_no" title="料仓号" is-link></van-cell> -->
                        <van-cell :value="dataInfo.balance.stock_no" title="料仓号" is-link></van-cell>
                        <van-field
                            v-model="dataInfo.quality.deduction_weight"
                            input-align="right"
                            type="number"
                            label="扣吨"
                            :readonly="isEnabledStandard"
                        ></van-field>
                        <van-field
                            v-model="dataInfo.quality.deduction_weight_rate"
                            input-align="right"
                            type="number"
                            label="扣吨百分比"
                            readonly
                        >
                            <template #right-icon>
                                %
                            </template>
                        </van-field>
                        <van-field
                            v-model="dataInfo.quality.base_water_content"
                            input-align="right"
                            type="number"
                            label="基础含水率"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="dataInfo.quality.water_content"
                            input-align="right"
                            type="number"
                            label="实际含水率"
                            :readonly="isEnabledStandard"
                        ></van-field>
                        <van-field
                            v-model="dataInfo.quality.remarks"
                            rows="1"
                            autosize
                            label="处理意见"
                            type="textarea"
                            maxlength="50"
                            placeholder="请输入意见"
                            show-word-limit
                        ></van-field>
                    </van-cell-group>
                </div>
            </div>
            <div class="panel">
                <div class="title">
                    <label><i class="iconfont iconxiangji"></i>添加照片</label>
                    <div class="show-hide" @click="showImgList=!showImgList">
                        <span v-show="!showImgList">展开<i class="iconfont iconshuangjiantouxia"></i></span>
                        <span v-show="showImgList">收起<i class="iconfont iconshuangjiantoushang"></i></span>
                    </div>
                </div>
                <div class="img-wrapper" v-show="showImgList">
                    <div class="img-list">
                        <van-uploader
                            v-model="fileList"
                            preview-image
                            preview-full-image
                            multiple
                            :max-count="10"
                            :max-size="10000 * 1024"
                            @oversize="onOversize"
                            upload-icon="plus"
                            @delete="deleteFile"
                            :before-read="uploadFileBefore"
                            :after-read="uploadFileMethod"
                        ></van-uploader>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-btns">
            <van-button type="default" @click="handleSave(1)" :disabled="disableBtn">
                保存
            </van-button>
            <van-button
                v-if="dataInfo.quality.handle_result==4"
                type="info"
                block
                @click="handleSave(2)"
                :disabled="disableBtn"
            >
                提交审批
            </van-button>
            <van-button
                v-else
                type="info"
                @click="handleSave(2)"
                :disabled="isEnabledStandard&&!dataInfo.quality.handle_result || disableBtn"
            >
                确认
            </van-button>
        </div>
        <van-popup
            style="width:90%;"
            v-model="selectSiloShow"
            class="selectSilo"
            closeable
            round
        >
            <h4>料仓选择</h4>
            <van-radio-group v-model="dataInfo.balance.stock_no">
                <template v-for="(item,index) in siloData">
                    <van-radio
                        :key="index"
                        :name="item.stock_code"
                    >
                        <div class="van_left stock_attr">
                            <span>{{ item.team_name }}</span>
                            <span>{{ item.stock_no }}</span>
                            <p>{{ item.stock_name }}</p>
                        </div>
                        <div class="van_right inventory">
                            <div class="physicalInventory" :class="{'earlyWarning': item.volume_theory < item.volume_warn_today}">
                                <h4>{{ item.volume_theory || 0 }}吨</h4>
                                <p>实际库存</p>
                            </div>
                            <div class="earlyWarningInventory">
                                <h4>{{ item.volume_warn_today || 0 }}吨</h4>
                                <p>预警库存</p>
                            </div>
                        </div>
                    </van-radio>
                </template>
            </van-radio-group>
            <div class="btns">
                <van-button type="default" @click="selectSiloShow=false">
                    取消
                </van-button>
                <van-button type="info" @click="confirmSelection">
                    确认
                </van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
export default {
    name: 'test-form',
    props: {
        // 当前快检对象
        testObj: Object,
    },
    mixins: [mixin_fileUpload],
    data() {
        return {
            biid: '',
            handle_opinions: '',
            // 选择料仓弹出层状态
            selectSiloShow: false,
            // 待选料仓数据
            siloData: [],

            showPopover: true,
            // 显示快检项目
            showItem: true,
            // 显示图片列表
            showImgList: true,
            // 显示处理结果
            showResult: true,
            // 流程id
            business_instance_id: '',
            dataInfo: {
                // 基本信息
                balance: {},
                // 处理结果
                quality: {},
                // 快检信息
                qualityDetails: [],
            },

            // 当前检测项
            curTestItem: {},

            // 是否启用标准
            isEnabledStandard: false,

            // 禁用操作按钮
            disableBtn: false,
            fileDataId: '',
        };
    },
    watch: {},
    created() {
        this.biid = this.testObj.id;
        this.initPage();
    },
    methods: {
        // 初始化
        async initPage() {
            await this.getData();
            await this.getStationStandardEnabled();
            await this.getFileList();
            await this.getStockList();
        },
        // 获取数据
        async getData() {
            this.$toast.loading();
            try {
                const url = '/interfaceApi/procurement/balance/quality/1'
                        + `?biid=${this.biid}&business_instance_id=${this.business_instance_id}`;
                const res = await this.$axios.get(url);
                this.dataInfo.balance = res.balance || {};
                this.dataInfo.quality = res.quality || {};
                this.dataInfo.qualityDetails = (res.qualityDetails || []).map(item => {
                    item.unit = item.unit || '';
                    return item;
                });
                this.$toast.clear();
            } catch (e) {
                if (e.ErrorCode) {
                    this.$toast.fail(e.ErrorCode.Message);
                }
            }

        },
        // 保存
        async handleSave(type) {
            if (type === 2) {
                if (!this.dataInfo.quality.handle_result) {
                    this.$toast.fail('请先完成质检');
                    return;
                }
            }
            this.disableBtn = true;
            this.$toast.loading({ duration: 0 });
            try {
                const url = `/interfaceApi/procurement/balance/quality/save/${type}`;
                const res = await this.$axios.post(url, this.dataInfo);
                if (res) {
                    this.dataInfo = res;
                    // 保存文件
                    // await this.uploadRequest();

                    this.$toast.success('操作成功');
                    this.$emit('callback', type);
                    if (type === 2 ) { // 如果是提交审批
                        if (this.dataInfo.quality.handle_result === 4) {
                            const business_instance_id = res.quality.business_instance_id;
                            const BusinessProcessId = res.quality.BusinessProcessId;
                            this.$nextTick(() => {
                                this.openProcess(business_instance_id, BusinessProcessId);
                            });
                        }
                    }
                }
                this.disableBtn = false;
            } catch (e) {
                if (e.ErrorCode) {
                    this.$message.error(e.ErrorCode.Message);
                }
            } finally {
                this.$toast.clear();
            }
        },
        // 打开流程办理
        openProcess(business_instance_id, BusinessProcessId) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: {
                        BusinessCode: 'CG_YCLBHGJS_SP',
                        BusinessInstanceId: business_instance_id,
                        BusinessProcessId: BusinessProcessId,
                    },
                    isReadOnly: false,
                    backPathName: 'qualityInspection',
                },
            });
        },
        // 通过场站组织机构ID获取原材料是否启动规范快检
        async getStationStandardEnabled() {
            const url = `/interfaceApi/baseinfo/stationmanger/get_station_standard_quality_enabled/${this.dataInfo.balance.station_id}`;
            const res = await this.$axios.get(url,);
            if (res) {
                this.isEnabledStandard = true;
            }
        },
        // 显示料仓弹框
        showStockPop() {
            if (this.siloData.length === 0) {
                this.$toast('没有可选料仓！');
            } else {
                this.selectSiloShow = true;
            }
        },
        // 获取料仓列表
        getStockList() {
            this.$axios
                .post(`/interfaceApi/procurement/balance/choosestock/${this.biid}`)
                .then(res => {
                    if (res && res.length > 0) {
                        this.siloData = res;
                    }
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 设置结果
        setResult(item) {
            if (item.actual_value === '' || item.actual_value === null) {
                item.result = 0;
            } else if (item.standard_index && this.getExpression(item.standard_index, item.index_type, item.actual_value)) {
                item.result = 1;
                // eslint-disable-next-line no-eval
            } else if (item.compromise_index && this.getExpression(item.compromise_index, item.index_type, item.actual_value)) {
                item.result = 2;
            } else {
                item.result = 3;
            }
            // 设置扣吨
            this.setDeductionWeight(item);
            // 设置含水率
            this.setWater(item);
            // 初始化 合格个数，不合格个数，让步个数
            let standardNum = 0; let noStandardNum = 0; let compromiseNum = 0;
            // 所有的必检项 是否检测完
            let mustCheckAll = true;

            // 筛选所有:有一个不合格 测试结果为不合格/让步/合格
            for (const o of this.dataInfo.qualityDetails) {
                if (o.result === 1) {
                    standardNum++;
                } else if (o.result === 2) {
                    compromiseNum++;
                } else if (o.result === 3) {
                    noStandardNum++;
                }
                if (o.is_must_check && o.result === 0) {
                    mustCheckAll = false;
                }
            }

            // 最终计算总结果 按低级不合格开始...
            let defaultResult = 0;

            // 必检项全部检测完成 计算最终结果
            if (mustCheckAll) {
                if (noStandardNum > 0) {
                    defaultResult = 3;
                } else if (compromiseNum > 0) {
                    defaultResult = 2;
                } else if (standardNum > 0) {
                    defaultResult = 1;
                }
            }
            this.dataInfo.quality.handle_result = this.dataInfo.quality.result = defaultResult;
        },
        // 设置扣吨
        async setDeductionWeight(item) {
            // 不是让步的时候 计算当前扣吨百分比
            if (item.result === 2 && item.actual_value !== '' && item.actual_value !== null) {
                if (item.index_type === 0 ) {
                    // 是否自动扣吨 且扣吨配置值存在
                    if (item.is_deduction_weight && item.out_value && item.deduction_weight_value) {
                        const arr = item.compromise_index.split('|');
                        const deduction_weight_value = item.deduction_weight_value.split('|')[0];
                        if (item.out_symbol === '超') {
                            const min = Math.min(arr[1], arr[4]);
                            // eslint-disable-next-line max-len
                            item.deduction_weight_rate = NP.times(NP.divide( NP.minus(item.actual_value, min), item.out_value), deduction_weight_value);
                        } else if (item.out_symbol === '低') {
                            const max = Math.max(arr[1], arr[4]);
                            // eslint-disable-next-line max-len
                            item.deduction_weight_rate = NP.times(NP.divide( NP.minus(max, item.actual_value), item.out_value), deduction_weight_value);
                        }
                    }
                    if (item.deduction_weight_rate < 0) {
                        item.deduction_weight_rate = 0;
                    }
                }
            } else {
                item.deduction_weight_rate = null;
            }

            // 计算累计扣吨
            let total = 0;
            for (const obj of this.dataInfo.qualityDetails) {
                if (obj.deduction_weight_rate) {
                    total += obj.deduction_weight_rate;
                }
            }
            this.dataInfo.quality.deduction_weight_rate = total;
        },
        // 设置含水率
        setWater(item) {
            if (item.item_name.indexOf('含水率') !== -1) {
                this.dataInfo.quality.water_content = item.actual_value;
            }
        },
        // 生成表达式js index_value指标对象
        /** *
             * 生成表达式js 判断是否符合当前指标
             * @param index_value  指标对象
             * @param index_type   指标类型
             * @param actual_value 当前设置的值
             * @returns {boolean}
             */
        getExpression(index_value, index_type, actual_value) {
            index_value = this.getItemStr(index_value);
            index_value = index_value.replace(/=/g, '==').replace(/≥/g, '>=').replace(/≤/g, '<=');
            let resultJs = true;
            // 指标类型区间
            if (index_type === 0) {
                const val = this.getItemStr(index_value);
                resultJs += '&&' + actual_value + val.replace('并且', '&&' + actual_value).replace('或者', '||' + actual_value);
                // 指标类型 指定值
            } else if (index_type === 1) {
                resultJs += `&&'${index_value}'=='${actual_value}'`;
            }

            // eslint-disable-next-line no-eval
            return eval(resultJs);
        },
        // 获取指标字符串
        getItemStr(str) {
            return (str || '').replace(/\|/g, '');
        },
        // 获取带单位的字符串
        getUnitStr(str, unit, index_type) {
            str = str || '';
            if (unit) {
                // 区间
                if (index_type === 0) {
                    const arr = str.split('|');
                    if (arr[1]) {
                        arr[1] += unit;
                    }
                    if (arr[4]) {
                        arr[4] += unit;
                    }
                    str = arr.join('|');
                } else {
                    // 指定值
                    // eslint-disable-next-line no-lonely-if
                    if (str) {
                        str += unit;
                    }
                }

            }
            return this.getItemStr(str);
        },
        // 检测每项结果文本
        getTestResultText(result) {
            switch (result) {
                case 1:
                    return {
                        txt: '合格',
                        class: 'hege',
                    };
                case 2:
                    return {
                        txt: '让步接收',
                        class: 'rangbujieshou',
                    };
                case 3:
                    return {
                        txt: '不合格',
                        class: 'tuihuo',
                    };
                default:return {
                    txt: '-',
                    class: 'hege',
                };
            }
        },

        // 确认选择料仓
        confirmSelection() {
            const data = this.siloData.find(item => item.stock_code === this.dataInfo.balance.stock_no);

            this.dataInfo.balance.stock_id = data.stock_id;
            this.dataInfo.balance.stock_code = data.stock_code;
            this.dataInfo.balance.stock_name = data.stock_name;
            this.dataInfo.balance.stock_no = data.stock_no;
            this.dataInfo.balance.stock_material_id = data.stock_material_id;
            this.dataInfo.balance.team_id = data.team_id;
            this.dataInfo.balance.team_name = data.team_name;
            this.selectSiloShow = false;
        },
        onOversize() {
            this.$toast.fail('文件大小不能超过10mb');
        },

        changeResult(result) {
            this.dataInfo.quality.handle_result = result;
        },
        callBackFun(res) {
            if (res && res.FileID) {
                this.filesGroupId = res.FileID;
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
    .test-form
        h4
            font-size 18rpx
            line-height 46rpx
            text-align center
            border-bottom 1px solid #ebedf0
        .popup-container
            max-height: calc(100vh - 70px);
            overflow-y: auto;
            padding-bottom 70rpx;
            .van-button
            .van-button
                width calc(100% - 20rpx)
                margin 20rpx 10rpx
                border-radius 4px
            .panel
                width 90%;
                box-shadow: 1px 1px 4rpx 0px rgba(52, 149, 251, 0.35);
                margin 20rpx auto;
                border-radius: 4rpx;
                overflow hidden
                .title
                    width 100%
                    height 44rpx
                    padding 0 14rpx;
                    display flex
                    justify-content space-between
                    align-items center
                    color #fff
                    background: linear-gradient(270deg, #587EAC 0%, #4C658A 100%);
                    label
                        .iconfont
                            margin-right 5rpx
                        font-size 16rpx;
                    .show-hide
                        span
                            padding 2rpx 5rpx
                            font-size 12rpx
                            border-radius: 0.02rem;
                            border: 1px solid rgba(255, 255, 255, 0.2);
                            .iconfont
                                font-size 12rpx
                .van-radio-group
                    padding-left 14rpx;
                    margin 10rpx 0 10rpx 0;
                    font-size 14rpx;
                    display flex
                    .van-radio--horizontal
                        margin-right 4rpx
                    .van-radio__label
                        margin-right 1rpx
                    .van-cell::after
                        left 0;
                        right 0;
                    >>> .van-radio__icon--checked .van-icon
                        background-color #4c658a
                        border-color #4c658a
                        color #fff
                .item-pannel
                    margin 10rpx;
                    box-shadow: 1px 1px 4rpx 0px rgba(52, 149, 251, 0.35);
                    border-radius: 4rpx;
                    border: 1px solid #C4C4C4;
                .row-item
                    display flex
                    justify-content space-between;
                    align-items center
                    flex-wrap: wrap;
                    padding 8rpx 14rpx;
                    .au-item-title
                        font-size 14rpx;
                        color #333;
                        font-weight bold
                        padding 0;
                        &.must-check:before
                            display inline-block
                            width 0
                            height 0
                            content '*'
                            color red
                            margin-right 8rpx
                        .diff-weight
                            margin-left 3rpx
                            padding 2rpx 4rpx
                            background: #F4FAFE;
                            border: 1px solid #E9F3F9;
                            color #3D7097
                            font-size 12rpx
                    .real
                        font-weight normal
                        font-size 12rpx
                        line-height 20rpx
                        color #666;
                        display flex
                        align-items center
                        white-space nowrap
                        .van-radio-group
                            margin 0;
                    .state
                        font-size 14rpx;
                        color #979EA7
                        .iconiconset0143
                            color #CD9F54
                            margin-left 3rpx;
                        &.hege
                            color #0189FC
                        &.rangbujieshou
                            color #FA8F00
                        &.tuihuo
                            color #E02020

                    .rel-val
                        margin-left 5rpx;
                        font-size 14rpx;
                        position relative
                        input
                            width: 75rpx;
                            height: 32rpx;
                            background: #F8F8F8;
                            border-radius: 4rpx;
                            border: 1px solid rgba(215, 215, 215, 0.2);
                            padding-left 10rpx;
                        .unit
                            position absolute
                            top 0
                            right 4rpx
                            height 100%
                            display flex
                            align-items center
            .item-title
                width 90%;
                padding 0rpx 0 5rpx;
                margin  5rpx    auto;
            .show-item-title
                padding 14rpx;
                box-shadow: 1px 1px 4rpx 0px rgba(52, 149, 251, 0.35);
                margin 20rpx auto;
                border-radius: 4rpx;
                display flex
                justify-content space-between
                align-items center
                .show-item
                    width: 50rpx;
                    height: 24rpx;
                    background: #F0F0F0;
                    border-radius: 2rpx;
                    display flex
                    justify-content center
                    align-items center;
                    font-size 12rpx;
                    color #666666
            .img-wrapper
                padding-left 10rpx
                h2
                    font-size 14rpx;
                    color #666666;
                    .iconfont
                        margin-right 3rpx
                .img-list
                    margin-top 10rpx
                    width 100%;
                    overflow-x auto;
                    padding-bottom 5rpx;
                    .van-uploader
                        width max-content
                        >>> .van-image,>>> .van-uploader__upload
                            width 72rpx;
                            height 72rpx
            .test-result
                background: #FFFBE6;
                box-shadow: 0px 0px 6rpx 0px rgba(0, 0, 0, 0.3);
                border-radius: 4rpx;
                .title
                    background: linear-gradient(270deg, #F4A43F 0%, #FF8133 100%);
                .result-radio
                    padding 5rpx 0
                    >>> .van-radio__icon--checked .van-icon
                        background-color #FF7400
                        border-color #FF7400
                        color #fff
        .footer-btns
            padding 15rpx;
            width 100%;
            position absolute
            left 0
            bottom 0
            background #fff;
            box-shadow: 1px 1px 4rpx 0px rgba(52, 149, 251, 0.35);
            display flex
            justify-content space-between
            .van-button
                flex 1
                margin 0 5rpx
        .selectSilo
            border-radius 4rpx
            .van-radio-group
                max-height 350rpx
                overflow-y auto
            .van-radio
                min-height 52rpx
                padding 0 10rpx
                /*border-bottom 1px solid #F1F1F1*/
                &:nth-child(2n)
                    background #f8f8fd
                &:last-child
                    border none
            >>>.van-radio__label
                width 100%
                display flex
                align-items center
                >span
                    font-size 12rpx
                    display flex
                    width calc(100% - 160rpx)
                    align-items center
                    height 40rpx
                .stock_attr
                    width: 51%;
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    font-size 12rpx;
                    span
                        display flex
                        justify-content center
                        width 50%;
                    p
                        display flex
                        justify-content center
                        width 100%;
                /*border-top: 1px solid #eee;*/
                .inventory
                    display flex
                    width 48%;
                    div
                        width 80rpx
                        height 100%;
                        padding 5rpx 0
                        text-align center
                        margin-left 6rpx
                        &:first-child
                            margin-left 0
                        h4,p
                            width 100%
                        h4
                            font-size 12rpx
                            line-height 20rpx
                            border none
                        p
                            font-size 10rpx
                            line-height 14rpx
                    .physicalInventory
                        background #EFFEFB
                        h4
                            color #009574
                        p
                            color #689389
                        &.earlyWarning
                            background #FFF6F6
                            h4
                                color #EC3032
                            p
                                color #9C7071
                    .earlyWarningInventory
                        background #F4F4F4
                        h4
                            color #666666
                        p
                            color #A2A2A2
            .btns
                button
                    width 50%
                    margin 0
                    float left
                    border-radius 0
        .van-popover__content
            border-radius 0;
    .popver-box
        min-width 120rpx;
        padding 12rpx;
        .zhibiao
            font-size 14rpx;
            color #666666
            margin 3rpx 0;
            span
                color #333333
</style>
